module.exports = __webpack_public_path__ + "img/1574392657.51ec0838.jpg";